<template>
  <div class="p-message-edit-confirm">
    <div class="p-message-edit-confirm-list">
      <div class="p-message-edit-confirm-list__item">
        <div class="p-message-edit-confirm__title">テスト名</div>
        <div class="p-message-edit-confirm__text">{{ abtest.abtest_name }}</div>
      </div>
      <div class="p-message-edit-confirm-list__item p-message-edit-confirm-list__item--desc">
        <div class="p-message-edit-confirm__title">テストする内容</div>
        <div class="p-message-edit-confirm__text">
          {{ abtest.memo }}
        </div>
      </div>
      <div class="p-message-edit-confirm-list__item">
        <div class="p-message-edit-confirm__title">プッシュ対象</div>
        <div class="c-tag">
          <ul class="c-tag-list">
            <li v-if="messageA.service_type == 2" class="c-tag-list__item c-tag-list__item--green">ブラウザ</li>
            <li v-if="messageA.service_type == 4" class="c-tag-list__item c-tag-list__item--green">カート</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    abtest: Object,
  },
  data: function () {
    return {};
  },
  computed: {
    messageA: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 0) {
        message = this.abtest.abtest_messages[0].message;
      }
      return message;
    },
    messageB: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 1) {
        message = this.abtest.abtest_messages[1].message;
      }
      return message;
    },
  },
}
</script>
